import { connect } from 'react-redux';

import DrivePowerTrainAndColour from 'vdp-used/components/DrivePowerTrainAndColourSection/DrivePowerTrainAndColourSection.jsx';

function mapStateToProps(state) {
    return {
        vehicle: state.vehicleV25,
    };
}

export default connect(mapStateToProps)(DrivePowerTrainAndColour);
